// extracted by mini-css-extract-plugin
export default {"sns":"SNSWrapper_sns__q5vSs"};